import styled from 'styled-components';
// import {
//     COLOR,
//     FONT
// } from 'assets'

export const CreatorUploadFormSec2Styled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  .item_layout {
    margin-bottom: 10px;
  }
  .button_layer {
    text-align: right;
  }
`;
